module.exports = __webpack_public_path__ + "img/yalibiao.prt.25f8313e.jpg";